import { render, staticRenderFns } from "./CreateOrUpdateEntity.vue?vue&type=template&id=cbc20d8e"
import script from "./CreateOrUpdateEntity.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateEntity.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdateEntity.vue?vue&type=style&index=0&id=cbc20d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports